export default "__VITE_ASSET__3213d00c__"